import React from 'react';

export default ({ style }) => (
  <svg viewBox="0 0 34 49" xmlns="http://www.w3.org/2000/svg" className={style}>
    <path d="M17 0C7.601 0 0 7.668 0 17.15 0 30.013 17 49 17 49s17-18.988 17-31.85C34 7.669 26.399 0 17 0z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/tour/assets/HSS_Pin.js